import React, { useState } from 'react';
import { Card, Button, Form, Row, Col } from 'react-bootstrap';
import { getDatabase, ref, push } from 'firebase/database';

const HomeworkPage = () => {
  const [viewType, setViewType] = useState('assign');

  const AssignHomework = () => {
    const [homeworkData, setHomeworkData] = useState({
      subject: '',
      class: '',
      description: '',
      dueDate: '',
      assignedBy: ''
    });

    const handleSubmit = async (e) => {
      e.preventDefault();
      try {
        const db = getDatabase();
        await push(ref(db, 'homework'), homeworkData);
        alert('Homework assigned successfully!');
        setHomeworkData({
          subject: '',
          class: '',
          description: '',
          dueDate: '',
          assignedBy: ''
        });
      } catch (error) {
        console.error('Error assigning homework:', error);
        alert('Error assigning homework');
      }
    };

    return (
      <Card style={{ borderRadius: '15px' }}>
        <Card.Body>
          <h4>Assign New Homework</h4>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Subject</Form.Label>
                  <Form.Control
                    type="text"
                    value={homeworkData.subject}
                    onChange={(e) => setHomeworkData({...homeworkData, subject: e.target.value})}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Class</Form.Label>
                  <Form.Control
                    type="text"
                    value={homeworkData.class}
                    onChange={(e) => setHomeworkData({...homeworkData, class: e.target.value})}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>
            {/* Add more form fields */}
            <Button type="submit" variant="primary">Assign Homework</Button>
          </Form>
        </Card.Body>
      </Card>
    );
  };

  return (
    <div style={{ padding: '20px' }}>
      <h2 style={{ marginBottom: '30px', color: '#1976d2', fontWeight: '700' }}>Homework Management</h2>
      
      <div className="d-flex gap-2 mb-4">
        <Button 
          variant={viewType === 'assign' ? 'primary' : 'outline-primary'}
          onClick={() => setViewType('assign')}
        >
          Assign Homework
        </Button>
        <Button 
          variant={viewType === 'view' ? 'primary' : 'outline-primary'}
          onClick={() => setViewType('view')}
        >
          View Submissions
        </Button>
      </div>

      {viewType === 'assign' && <AssignHomework />}
      {viewType === 'view' && (
        <Card style={{ borderRadius: '15px' }}>
          <Card.Body>
            <h4>Homework Submissions</h4>
            {/* Add submissions view content */}
          </Card.Body>
        </Card>
      )}
    </div>
  );
};

export default HomeworkPage;
